import axios from 'axios';
import { AuthResponse } from '../../types/auth';

export const baseURL: string =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_BASE_URL || 'https://dev-radar-middleware.profsoft.online/api'
    : process.env.REACT_APP_BASE_URL || '';

export const http = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  baseURL,
});

http.interceptors.request.use(
  (config) => {
    // eslint-disable-next-line no-param-reassign
    const userJSON = localStorage.getItem('profile');
    if (userJSON) {
      const user: AuthResponse = JSON.parse(userJSON);
      config.headers.token = user.data.token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);
